<template>
  <validation-observer v-slot="{ valid, handleSubmit }">
    <b-form role="form" @submit.prevent="handleSubmit(update)">
      <b-row>
        <b-col cols="10">
          <base-input
            :alternative="false"
            class="mb-0"
            form-group-size="sm"
            form-group-classes="mb-0"
            name="Name"
            :rules="{ required: true }"
            :debounce="500"
            placeholder="Account Name"
            v-model="model.name"
            input-group-classes="mb-0"
            input-classes="form-control-sm"
          ></base-input>
        </b-col>
        <b-col cols="2" class="text-right">
          <base-button size="sm" type="default" :disabled="updating" @click="cancel">
            <i class="fa fa-times mr-0"></i>
            <span class="sr-only">Cancel</span>
          </base-button>

          <base-button size="sm" type="success" native-type="submit" :disabled="!valid">
            <i v-if="!updating" class="fa fa-check mr-0"></i>
            <i v-else class="fa fa-spin fa-spinner mr-0"></i>
            <span class="sr-only">Edit</span>
          </base-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { BaseAlert } from "@/components";
import { get } from "dot-prop";

export default {
  name: "account-name-edit-form",
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      updating: false,
      model: {
        name: null,
      },
    };
  },
  created() {
    this.model.name = this.account.name;
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    update() {
      this.updating = true;

      const requestBody = {
        name: this.model.name,
      };

      this.axios
        .patch(`/v1/accounts/${this.account.id}`, requestBody)
        .then((response) => {
          this.updating = false;
          if (response.data) {
            this.$emit("update-account", response.data);
          }

          // notify
          this.$notify({
            message: "Account updated",
            timeout: 3000,
            icon: "fa fa-check",
            type: "success",
          });
        })
        .catch((error) => {
          this.updating = false;
          this.errorMessage = "Failed to update account";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    },
  },
};
</script>
